import React, { Component } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import ProductTraceabilityItem from './ProductTraceabilityItem';
import uuid from 'uuid';
import { Set } from 'immutable';
import $ from 'jquery';

class ProductTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      products: props.products.map(product => {
        const newProduct = product.id
          ? product
          : { ...product, id: uuid(), virtual: true };
        return Object.assign(newProduct);
      }),
    };

    this.addProductBatch = this.addProductBatch.bind(this);
    this.updateProduct = this.updateProduct.bind(this);
    this.deleteProduct = this.deleteProduct.bind(this);
    this.generateInputs = this.generateInputs.bind(this);
    this.flagDuplicates = this.flagDuplicates.bind(this);
    this.addDeletedInput = this.addDeletedInput.bind(this);
  }

  componentDidMount() {
    this.setState({ products: this.flagDuplicates(this.state.products) });
    this.generateInputs();
  }
  componentDidUpdate() {
    this.generateInputs();
  }

  generateInputs() {
    $('div#traceabilities').html('');

    // TODO: better loop (this is fast and furious mode)
    let index = 0;
    this.state.products.map(product => {
      $('div#traceabilities').append(
        `<input type="hidden" name="traceabilities[${index}].id" value="${
          product.new || product.virtual ? 0 : product.id
        }" /> `
      );
      $('div#traceabilities').append(
        `<input type="hidden" name="traceabilities[${index}].batch" value="${product.batch ||
          ''}" /> `
      );
      $('div#traceabilities').append(
        `<input type="hidden" name="traceabilities[${index}].dlu" value="${product.dlu ||
          ''}" /> `
      );
      $('div#traceabilities').append(
        `<input type="hidden" name="traceabilities[${index}].product_id" value="${product.product_id ||
          ''}" /> `
      );
      $('div#traceabilities').append(
        `<input type="hidden" name="traceabilities[${index}].external_product_id" value="${product.external_product_id ||
          ''}" /> `
      );

      index++;
      return product;
    });
  }

  addDeletedInput(product) {
    if (!(product.virtual || product.new)) {
      const $inputLength = $('div#deleted_traces input').length;
      $('div#deleted_traces').append(
        `<input type="hidden" name="trace_deleted_ids[${$inputLength}]" value="${product.id}" /> `
      );
    }
  }

  flagDuplicates(products) {
    return products.map(existing => {
      const duplicate = products.filter(p => {
        if (p.product_id && p.product_id === existing.product_id) return true;
        if (
          p.external_product_id &&
          p.external_product_id === existing.external_product_id
        ) {
          return true;
        }
        return false;
      });

      return { ...existing, duplicate: duplicate.size >= 2 };
    });
  }

  addProductBatch(product) {
    const { products } = this.state;
    this.setState({
      products: this.flagDuplicates(products.add({ ...product, id: uuid() })),
    });
  }

  updateProduct(updatedProduct) {
    const { products } = this.state;
    this.setState({
      products: products.map(product => {
        if (product.id === updatedProduct.id) {
          return Object.assign(updatedProduct);
        }
        return product;
      }),
    });
  }

  deleteProduct(product) {
    const { products } = this.state;
    this.setState({ products: this.flagDuplicates(products.delete(product)) });
    this.addDeletedInput(product);
  }

  render() {
    if (this.state.products && this.state.products.size) {
      return (
        <div>
          <h5>Produits utilisés</h5>
          <table className="ui table">
            <thead>
              <tr>
                <th className="four wide">Produit</th>
                <th className="four wide">Substance active</th>
                <th className="three wide">N° de lot</th>
                <th className="two wide">DLU</th>
                <th className="one wide">Quick FDS</th>
                <th className="one wide" />
              </tr>
            </thead>
            <tbody>
              {this.state.products
                .sortBy(product => product.name)
                .map(t => (
                  <ProductTraceabilityItem
                    key={t.id}
                    product={t}
                    onDuplicate={this.addProductBatch}
                    onChange={this.updateProduct}
                    onDelete={this.deleteProduct}
                  />
                ))}
            </tbody>
          </table>
        </div>
      );
    }

    return <div />;
  }
}

ProductTable.propTypes = {
  products: ImmutablePropTypes.set,
};

ProductTable.defaultProps = {
  products: Set(),
};

export default ProductTable;



// WEBPACK FOOTER //
// ./src/modules/saas/pco/interventions/components/ProductTable.js